"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractLeaderSelect = ContractLeaderSelect;
exports.OtherContractModalBody = OtherContractModalBody;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const RepositoryReact_1 = __importDefault(require("../../../React/RepositoryReact"));
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const ContractModalBody_1 = require("./ContractModalBody");
const ContractsController_1 = require("../ContractsController");
const FormContext_1 = require("../../../View/Modals/FormContext");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
const InlineCreateDrawers_1 = require("../../../View/Modals/InlineCreateDrawers");
const ContractStructureTree_1 = require("./ContractStructureTree");
/**
 * Wskazanie lidera konsorcjum spośród już wybranych wykonawców.
 *
 * Renderuje się WYŁĄCZNIE przy więcej niż jednym wykonawcy — przy jednym nie ma czego
 * wybierać, więc pola nie ma w drzewie DOM; nie jest ukrywane stylem, żeby nie zostawiać
 * kontrolki, którą da się trafić klawiaturą albo czytnikiem ekranu.
 *
 * Wybór jest nieobowiązkowy. Firma wyrzucona z listy wykonawców przestaje być liderem,
 * bo wskazanie na podmiot spoza listy backend i tak odrzuca (400) — a zostawione „w tle"
 * byłoby stanem, którego użytkownik nie widzi na ekranie.
 */
function ContractLeaderSelect() {
    const { setValue, watch } = (0, FormContext_1.useFormContext)();
    const contractors = watch("_contractors") || [];
    const leaderEntityId = watch("_leaderEntityId");
    (0, react_1.useEffect)(() => {
        if (leaderEntityId === undefined || leaderEntityId === null)
            return;
        if (contractors.some((contractor) => contractor.id === leaderEntityId))
            return;
        setValue("_leaderEntityId", null, { shouldValidate: true, shouldDirty: true });
    }, [contractors, leaderEntityId, setValue]);
    if (contractors.length < 2)
        return null;
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "_leaderEntityId" },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Lider konsorcjum"),
        react_1.default.createElement(react_bootstrap_1.Form.Select, { value: leaderEntityId === undefined || leaderEntityId === null ? "" : String(leaderEntityId), onChange: (event) => setValue("_leaderEntityId", event.target.value ? Number(event.target.value) : null, {
                shouldValidate: true,
                shouldDirty: true,
            }) },
            react_1.default.createElement("option", { value: "" }, "\u2014 nie wskazano \u2014"),
            contractors
                .filter((contractor) => contractor.id !== undefined && contractor.id !== null)
                .map((contractor) => (react_1.default.createElement("option", { key: contractor.id, value: String(contractor.id) }, contractor.shortName ? `${contractor.name} (${contractor.shortName})` : contractor.name)))),
        react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Nieobowi\u0105zkowe. Wskazany lider staje si\u0119 pierwszy na li\u015Bcie wykonawc\u00F3w.")));
}
/**Wywoływana w ProjectsSelector jako props  */
function OtherContractModalBody(props) {
    const initialData = props.initialData;
    // ✅ Lokalne repository w useMemo - nie będzie kolizji z głównym contractsRepository
    const ourRelatedContractsRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        name: "ourRelatedContracts_temp",
        actionRoutes: { addNewRoute: "", editRoute: "", deleteRoute: "", getRoute: "contracts" },
    }), []);
    const { setValue, watch } = (0, FormContext_1.useFormContext)();
    const _project = watch("_project");
    const [showCreateContractor, setShowCreateContractor] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setValue("_type", initialData?._type, { shouldValidate: true });
        setValue("_contractors", initialData?._contractors || [], { shouldValidate: true });
        // `null`, a nie `undefined`: obiekt wysyłany przy edycji powstaje przez `lodash.merge`
        // z rekordu w repozytorium, a merge POMIJA `undefined` — czyli zdjęcie lidera nigdy
        // nie doszłoby do serwera. Jawny `null` nadpisuje i backend czyta go jako „bez lidera".
        setValue("_leaderEntityId", initialData?._leaderEntityId ?? null, { shouldValidate: true });
        setValue("_ourContract", initialData?._ourContract, { shouldValidate: true });
    }, [initialData, setValue]);
    function handleContractorCreated(created) {
        const current = watch("_contractors") || [];
        setValue("_contractors", [...current, created], { shouldValidate: true });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        " ",
        !props.isEditing ? react_1.default.createElement(BussinesObjectSelectors_1.ContractTypeSelector, { typesToInclude: "other" }) : null,
        react_1.default.createElement(ContractModalBody_1.ContractModalBody, { ...props }),
        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Wykonawcy"),
            react_1.default.createElement(BussinesObjectSelectors_1.EntitySelector, { name: "_contractors", multiple: true, onRequestCreate: () => setShowCreateContractor(true) })),
        react_1.default.createElement(ContractLeaderSelect, null),
        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Powi\u0105zana us\u0142uga IK lub PT"),
            react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: "_ourContract", labelKey: "ourId", searchKey: "contractOurId", contextSearchParams: {
                    _project,
                    typesToInclude: "our",
                }, repository: ourRelatedContractsRepository, renderMenuItemChildren: (option) => (react_1.default.createElement("div", null,
                    option.ourId,
                    " ",
                    option.name)) })),
        react_1.default.createElement(InlineCreateDrawers_1.EntityInlineCreateDrawer, { show: showCreateContractor, onHide: () => setShowCreateContractor(false), title: "Nowy podmiot (wykonawca)", repository: ContractsController_1.entitiesRepository, onCreated: handleContractorCreated }),
        !props.isEditing && react_1.default.createElement(ContractStructureTree_1.ContractStructureTree, null)));
}
